import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-platform-how-it-works',
  templateUrl: './platform-how-it-works.component.html',
  styleUrls: ['./platform-how-it-works.component.scss']
})
export class PlatformHowItWorksComponent implements OnInit {

  constructor(private viewportScroller: ViewportScroller) {

  }

  ngOnInit() {
    
  }

  ngOnDestroy(){    
    
  }

  public onClick(elementId: string): void { 
    this.viewportScroller.scrollToAnchor(elementId);
  }

}
